import React, { PureComponent } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { Row } from '@cuemath/comps';
import styled from 'styled-components';
import { IconButton } from 'modules/list';
import { FORM_ACTIONS } from 'constants/form';
import EditIcon from 'img/edit.png';
import COLORS from 'constants/colors';

import { epochToDate } from 'utils';

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  padding: 8px;
`;

export const demoOptions = [
  {
    label: 'True',
    value: true,
  },
  {
    label: 'False',
    value: false,
  },
];

class StudentSlotList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      students: [],
    };
  }

  static getDerivedStateFromProps(props, state) {
    let { courses, students } = props;
    const newState = {};
    let courseIdObj = {};

    courses &&
      Array.isArray(courses) &&
      courses.forEach(({ id, course_name: courseName }) => {
        courseIdObj[id] = courseName;
      });

    students &&
      Array.isArray(students) &&
      students.forEach(data => {
        const { student_course_id: studentCourseId } = data;
        if (courseIdObj[studentCourseId]) {
          data['course_name'] = courseIdObj[studentCourseId];
        } else {
          data['course_name'] = '-';
        }
      });
    newState.students = students || [];
    return newState;
  }

  getTableRowProps = (state, rowInfo, instance) => {
    if (!rowInfo) {
      return {};
    }
    return {
      style: {
        backgroundColor:
          rowInfo.original.status_name !== 'EXPIRED' ? COLORS.HAWKESBLUE : null,
        border: '4px solid white',
      },
    };
  };

  render() {
    const { openEditStudentSlotForm, courses = [] } = this.props;
    const { students } = this.state;

    let columnsData = [
      {
        Header: 'Status',
        accessor: 'status_name',
      },
      {
        Header: 'Teacher Name',
        accessor: 'teacher_name',
        width: 160,
      },
      {
        Header: 'Class Schedule',
        accessor: 'schedule',
      },
      {
        Header: 'Start date',
        accessor: 'start_date',
        Cell: ({ value }) => (value ? epochToDate(value, 'DD-MM-YYYY') : ''),
      },
      {
        Header: 'Valid till',
        accessor: 'end_date',
        Cell: ({ value }) => (value ? epochToDate(value, 'DD-MM-YYYY') : ''),
      },
      {
        Header: 'Slot type',
        accessor: 'type_name',
      },
      {
        Header: 'Course Name',
        accessor: 'course_name',
      },
      {
        Header: 'Auto Enter',
        accessor: 'is_demo',
        Cell: ({ value }) => (value ? 'True' : 'False'),
      },
    ];

    // active edit option when status true
    columnsData.push({
      Header: 'Action',
      accessor: 'name',
      Cell: row => {
        if (row.original.status !== 'EXP' && row.original.tag !== 'DEMO') {
          return (
            <Row justifyContent="space-around">
              <IconButton
                icon={EditIcon}
                onClick={() =>
                  openEditStudentSlotForm({
                    formType: FORM_ACTIONS.EDIT,
                    data: { ...row.original },
                    courses,
                  })
                }
              />
            </Row>
          );
        } else {
          return 'N/A';
        }
      },
    });

    const tableColumns = [
      {
        Header: ``,
        columns: columnsData,
      },
    ];

    return (
      <TableWrapper>
        <ReactTable
          data={students}
          getTrProps={this.getTableRowProps}
          className="-highlight"
          manual
          showPaginationTop
          showPageSizeOptions={false}
          filterable={false}
          sortable={false}
          resizable={false}
          defaultPageSize={5}
          defaultFilterMethod={(filter, row) => String(row[filter.id]) === filter.value}
          columns={tableColumns}
          style={{ maxHeight: 400, textAlign: 'center' }}
        />
      </TableWrapper>
    );
  }
}

export default StudentSlotList;
